import { useSession } from "@/lib/store";

export function SplashScreen() {
  return (
    <div className="flex h-full min-h-dvh flex-col items-center justify-center gap-4 bg-canvas">
      <span className="brandmark">Z</span>
      <div className="w-[180px]">
        <div className="skeleton mb-2" />
        <div className="skeleton w-3/4" />
      </div>
      <span className="sr-only">Carregando o Zapir</span>
    </div>
  );
}

export function useDisplayName(): string {
  const me = useSession((s) => s.me);
  return me?.name ?? "Usuário";
}
